import React from 'react';

function LighthouseIcon({ className = '', title = 'Lighthouse' }) {
  return (
    <svg
      className={`lighthouse-icon ${className}`.trim()}
      viewBox="0 0 48 48"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path className="lighthouse-ray" d="M18 12 6 8M30 12l12-4M17 17H5m26 0h12" />
      <path className="lighthouse-lantern" d="M18 16h12l-2-7h-8z" />
      <path className="lighthouse-roof" d="m16 9 8-5 8 5z" />
      <path className="lighthouse-tower" d="m19 17-5 25h20l-5-25z" />
      <path className="lighthouse-stripe" d="m17.8 23 12.4 0 1 5H16.8zm-2.2 11h16.8l1 5H14.6z" />
      <path className="lighthouse-window" d="M22 11h4v4h-4z" />
      <path className="lighthouse-base" d="M11 42h26v3H11z" />
      <path className="lighthouse-water" d="M7 47c3-2 5 2 8 0s5 2 8 0 5 2 8 0 5 2 10 0" />
    </svg>
  );
}

export default LighthouseIcon;

